import React, { FC } from "react"

import { IconUserBolt } from "@tabler/icons-react"
import { Text } from "@mantine/core"

import SettingsCard from "../settings-card/SettingsCard"
import { useLanguage } from "../../../contexts/language-context"
import OrganisationsSelect from "../organisations-select/OrganisationsSelect"
import { useAuth } from "../../../contexts/authentication-context"

const SuperAdminSettingsCard: FC = () => {
    const { L } = useLanguage()
    const { user, setOrganisation } = useAuth()

    return (
        <SettingsCard
            title={L("Super admin access")}
            icon={IconUserBolt}
            description={L(
                "Super admin accounts are meant for Ecomoni staff to access any organisation at will. Currently, you are viewing the dashboard as the %s organisation. Please select an organisation below.",
                <Text weight="bold" span>
                    {user?.organisation}
                </Text>,
            )}
        >
            <OrganisationsSelect
                value={user?.organisation}
                onChange={setOrganisation}
                maw="20rem"
                clearable={false}
                searchable
            />
        </SettingsCard>
    )
}

export default SuperAdminSettingsCard
